import React, {Component} from 'react';
import ImprovedKeywordInput from "../../UI/KeywordsInput/ImprovedKeywordInput";
// import classes from'./KeywordsInputWrapper.module.css';

class KeywordsInputWrapper extends Component  {
    render() {
        return (
            <dl className="row">
                <dt className="col-sm-3"><label>Keywords - Categories - Properties</label></dt>
                <dd className="col-sm-9">
                    <ImprovedKeywordInput
                        keywordsFilter={this.props.keywords_filter}
                        keywordsUpdate={this.props.keywordsUpdate}
                        updatePage={this.props.updatePage}
                        closePatternDetails={this.props.closePatternDetails}
                    />
                </dd>
            </dl>
        );
    }
}

export default KeywordsInputWrapper;